import { useDevice } from "../../../common/hooks/useDevice";
import { useState } from "react";
import { defaultButtonSectionValue } from "../../../common/components/card/CustomGraphCard";
import { CustomDropdownBoxButton } from "../../../common/components/button/CustomDropdownBoxButton";
import CustomPeriodButton from "../../../common/components/button/CustomPeriodButton";
import { Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { C1Text } from "../../../common/components/text/CustomText";
import PeakChart from "../../../common/components/chart/PeakChart";
import { Theme } from "../../../common/Theme";

function WorkingRateTrendChartCard() {
    const currentDevice = useDevice();

    const [dateRange, setDateRange] = useState(defaultButtonSectionValue[0].value);
    let buttonSection;
    if (currentDevice === "mobile") {
        buttonSection = (
            <CustomDropdownBoxButton
                icon={"date"}
                currentValue={dateRange}
                setValue={setDateRange}
                values={defaultButtonSectionValue}
            />
        );
    } else {
        buttonSection = (
            <CustomPeriodButton currentValue={dateRange} setValue={setDateRange} values={defaultButtonSectionValue} />
        );
    }

    return (
        <SizedBox
            border={`1px solid ${Theme.color.gray250}`}
            borderRadius={"16px"}
            width={"100%"}
            height={"392px"}
            alignItem={"flex-start"}
            justifyContent={"flex-start"}
            padding={"16px"}
            backgroundColor={"transparent"}
        >
            <Row width={"100%"} justifyContent={"space-between"} alignItem={"flex-start"}>
                <C1Text>Working Rate Trend</C1Text>
                {buttonSection}
            </Row>
            <SizedBox height={"15px"} />
            <PeakChart />
        </SizedBox>
    );
}

export default WorkingRateTrendChartCard;
